const colors = {
    // Primary
    midnight: '#051D33',
    sky: '#00B6C9',
    sunset: '#FC4C02',
    sunrise: '#FFB600',
    // Primary shades
    blend: '#C8E6F1',
    fuse: '#92D2E7',
    skyDarker: '#007191',
    skyDarkest: '#004C60',
    sunriseDarker: '#996D00',
    sunriseDarkest: '#775500',
    sunriseLighter: '#FFD877',
    sunriseLightest: '#FFF6DE',
    sunsetDarker: '#B93801',
    sunsetDarkest: '#862901',
    sunsetLighter: '#FD6423',
    sunsetLightest: '#FE8756',
    // Status
    errorRed: '#AB1212',
    lightBlue: '#F3FAFD',
    lightGreen: '#E6F7E7',
    lightPink: '#FDF3F2',
    successGreen: '#1C7D26',
    // Neutrals
    cement: '#54575A',
    grey: '#C3C3C3',
    lightGrey: '#EEEEEE',
    meld: '#707272',
    offWhite: '#FAFAFA',
    white: '#FFFFFF',
    // Secondary
    deep: '#00677F',
    lush: '#93C90F',
    punch: '#FF5869',
    tide: '#1DA897',
    zest: '#FFF203',
    // Auxillary
    black: '#000000',
};
const opacify = (color, opacity) => {
    return [color, Math.round(opacity * 255).toString(16)].join('');
};
export default colors;
export { opacify };
